export default {
  setSurnamesRegisterState(state, surnames) {
    state.surnames = surnames;
  },
  setRegisterReferralDataState(state, data) {
    state.registerReferralData = data;
  },
};
